

import React, { createContext, useReducer, useState } from "react";
import { UserReducers } from "../reducers/UserReducers";
import { UserTypes } from "../types/UserTypes";

export const UserContext = createContext()

export function UserProvider(props) {
    const [pkce, setPkce] = useState({ codeVerifier: "", codeChallenge: "" });
    const [datosUsuario, setDatosUsuario ] = useState()
    
    // Validar y parsear datos de sesión de forma más robusta
    const getSessionData = () => {
        try {
            const encoded = localStorage.getItem('pm-session');
            if (!encoded || encoded.trim() === '') {
                console.warn('No hay datos de sesión en localStorage');
                return null;
            }
            const decifrado = atob(encoded);
            if (!decifrado || decifrado.trim() === '') {
                console.warn('Datos de sesión decodificados están vacíos');
                return null;
            }
            const parseado = JSON.parse(decifrado);
            console.log('Datos de sesión cargados correctamente:', parseado);
            return parseado;
        } catch (error) {
            console.error('Error al parsear sesión:', error);
            console.warn('Se usarán valores por defecto');
            return null;
        }
    };
    
    const datosSession = getSessionData();
    const initialUserState = {
        codUsuario: datosSession?.uid ? datosSession.uid : 0,
        nomUsuario: datosSession?.nomUsuario ? datosSession.nomUsuario.toLowerCase() : '',
        token: datosSession?.token || datosSession?.refresh_token || '',
        tokenExpire: datosSession?.tokenExpire || 0,
        menus: datosSession?.menus || [],
        permisos: datosSession?.permisos || [],
        codUsuarioTipo: datosSession?.rol || '',
        nomCarpetaFoto: datosSession?.nomCarpetaFoto || '',
        nomFoto: datosSession?.nomFoto || '',
        uid: datosSession?.uid ? datosSession.uid.toString() : ""
    }
    const [ state, dispatch ] = useReducer(UserReducers, initialUserState)
    
    const signIn = (objSession) => {
        var cifrado = btoa(JSON.stringify(objSession));
        localStorage.setItem('pm-session', cifrado);
        setDatosUsuario(objSession)
        dispatch({type: UserTypes.SIGN_IN, payload: objSession})
    }

    const signOut = () => {
        localStorage.clear();
        sessionStorage.clear();
        dispatch({type: UserTypes.SIGN_OUT})
    }

    return (
        <UserContext.Provider value={{stateUser: state, datosUsuario, signIn, signOut}}>
            {props.children}
        </UserContext.Provider>
        
    )
}